export const routes = [
  {
    path: '/',
    name: 'funds',
    component: () => import('@/pages/funds/FundsPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: { template: '<div>Not Found</div>' },
  },
];
